<ng-container>
  <header id="topnav" class="defaultscroll scroll-active">
    <div class="container">
      <!-- Logo container-->
      <div>
        <a href="https://www.crengland.com/" class="logo">
          <img src="./assets/images/cre-wordmark-white.svg" alt="" class="logo-light" height="28" />
        </a>
      </div>
      <!-- End Logo container-->
      <div class="menu-extras">
        <div class="menu-item">
          <!-- Mobile menu toggle-->
          <a id="mobileNavBar" class="navbar-toggle" (click)="this.openMobileNavBar()">
            <div class="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </a>
          <!-- End mobile menu toggle-->
        </div>
      </div>

      <div id="navigation">
        <!-- Navigation Menu-->
        <ul class="navigation-menu">
          <li
            *ngFor="let item of menuItems"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="has-submenu"
          >
            <a routerLink="{{ item.routerLink }}">{{ item.label }}</a>

            <span
              *ngIf="item.items"
              class="menu-arrow"
              (click)="toggleMobileSubMenu($event)"
            ></span>
            <ul *ngIf="item.items" class="submenu">
              <li *ngFor="let subItem of item.items" class="has-submenu">
                <a [routerLink]="subItem.routerLink">{{ subItem.label }}</a>
              </li>
            </ul>
          </li>
          <li class="has-submenu">
            <a href="javascript:void(0);" (click)="toggleMobileSubMenu($event)">Careers</a>
            <span class="menu-arrow" (click)="toggleMobileSubMenu($event)"></span>
            <ul class="submenu">
              <li>
                <a routerLink="/">Experienced Drivers</a>
              </li>
              <li>
                <a href="https://schools.crengland.com/">Get Your CDL</a>
              </li>
              <li>
                <a href="https://careers.crengland.com/office/">Office Jobs</a>
              </li>
              <li>
                <a href="https://careers.crengland.com/maintenance/">Maintenance Jobs</a>
              </li>
              <li>
                <a href="https://careers.crengland.com/veterans/">Veteran Program</a>
              </li>
            </ul>
          </li>
          <li>
            <a href="https://schools.crengland.com/cdl-training-schools/">Schools</a>
          </li>
          <li>
            <a href="https://career.crengland.com/apply">Sign In</a>
          </li>
        </ul>
        <!-- End navigation menu-->
      </div>
    </div>
  </header>
</ng-container>
